import React, { useEffect, useState, createContext } from 'react';
import { api } from '../services';

const AuthContext = createContext({
    status: false,
    userName: null,
    token: null,
    idPerson: null,
    idPersonRoot: null,
    userCountry: "",
    personName: "",
    region: "",
    isLoading: false,
    updateAuthContext: () => { },
    deleteAuthContext: () => { },
});

export const AuthContextProvider = ({ children }) => {
    const [region, SetRegion] = useState(null);
    const [userName, setUserName] = useState(null);
    const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [idPerson, setIdPerson] = useState(null);
    const [idPersonRoot, setIdPersonRoot] = useState(null);
    const [userCountry, setUserCountry] = useState(null);
    const [personName, setPersonName] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        updateAuthContext();
    }, []);

    const updateAuthContext = async () => {
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const embedToken = queryParams.get('embedToken');

            if (embedToken && !localStorage.getItem('token')) {
                function parseJwt(base64Token) {
                    var base64Url = base64Token.split('.')[1];
                    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    var jsonPayload = decodeURIComponent(window.atob(base64)
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                    );
                    return JSON.parse(jsonPayload);
                }
                const decodedToken = parseJwt(embedToken);
                const { username, region, idPerson, idPersonRoot } = decodedToken;

                localStorage.setItem('userName', username);
                localStorage.setItem('idPerson', idPerson);
                localStorage.setItem('idPersonRoot', idPersonRoot);
                localStorage.setItem('region', region);
                localStorage.setItem('token', embedToken);
            }
        } catch (e) {
        }

        const userName = localStorage.getItem('userName');
        const region = localStorage.getItem('region');
        const token = localStorage.getItem('token');
        const idPerson = localStorage.getItem('idPerson');
        const idPersonRoot = localStorage.getItem('idPersonRoot');
        const userCountry = localStorage.getItem('userCountry');
        const personName = localStorage.getItem('personName');

        api.defaults.headers.Authorization = `Token ${token}`;
        setToken(token);
        setUserName(userName);
        SetRegion(region);
        setIdPerson(idPerson);
        setIdPersonRoot(idPersonRoot);
        setUserCountry(userCountry);
        setPersonName(personName)

        setTimeout(() => setIsLoading(false), 500);
    };

    const deleteAuthContext = async () => {
        localStorage.removeItem('userName');
        localStorage.removeItem('region');
        localStorage.removeItem('token');
        localStorage.removeItem('idPerson');
        localStorage.removeItem('idPersonRoot');
        localStorage.removeItem('userCountry');
        localStorage.removeItem('personName');

        setUserName(null);
        SetRegion(null);
        setToken(null);
        setIdPerson(null);
        setIdPersonRoot(null);
        setUserCountry(null);
        setPersonName(null);
        api.defaults.headers.Authorization = null;

        setTimeout(() => setIsLoading(false), 500);
    };

    return (
        <AuthContext.Provider
            value={{
                status: !!token,
                token,
                isLoading,
                region,
                userName,
                idPerson,
                idPersonRoot,
                userCountry,
                personName,
                updateAuthContext,
                deleteAuthContext,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
